import React from "react";

const SS = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Soft Skills</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Data Storytelling</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Stakeholder Communication</h3>
              <span className="skills__level">Proficient</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Collaboration</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          {/* Add more skills if needed */}
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Project Management</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Leadership</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Presentation Skills</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          {/* Add more skills if needed */}
        </div>
      </div>
    </div>
  );
};

export default SS;
